module.exports = __webpack_public_path__ + "img/PEAK_Logo.ace9e25d.png";